__webpack_require__.p = "/munamii-cakery/";